const AUTH_SESSION_KEY = 'wbuoa.auth';
const LEGACY_KEYS = ['user', 'token', 'authToken'];

const safeParse = (value) => {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const loadAuthSession = () => {
  const storedSession = safeParse(sessionStorage.getItem(AUTH_SESSION_KEY));
  if (storedSession?.user) {
    return storedSession;
  }

  // Migrate only the old session value. A stale localStorage "user" value was
  // the reason protected navigation could remain visible after logout.
  const legacyUser = safeParse(sessionStorage.getItem('user'));
  if (!legacyUser) return null;

  const session = {
    user: legacyUser,
    token: sessionStorage.getItem('authToken') || sessionStorage.getItem('token') || null
  };
  sessionStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
  return session;
};

export const saveAuthSession = ({ user, token = null }) => {
  const session = { user, token };
  sessionStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
  sessionStorage.setItem('user', JSON.stringify(user));

  if (token) {
    sessionStorage.setItem('authToken', token);
  } else {
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('token');
  }
};

export const clearAuthSession = () => {
  sessionStorage.removeItem(AUTH_SESSION_KEY);
  LEGACY_KEYS.forEach((key) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  });
};

export const getStoredToken = () => {
  const session = loadAuthSession();
  return session?.token || null;
};

